import { render } from "./CXCompetitorSettings.vue?vue&type=template&id=f69df63a&scoped=true"
import script from "./CXCompetitorSettings.vue?vue&type=script&lang=js"
export * from "./CXCompetitorSettings.vue?vue&type=script&lang=js"

import "./CXCompetitorSettings.vue?vue&type=style&index=0&id=f69df63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f69df63a"]])

export default __exports__